const UploadFinalStandings = 1;
const PostEventSetup = 2;
const Advancers = 3;
const FeePayment = 4;

export const STEP_SEQUENCE = {
	UploadFinalStandings,
	PostEventSetup,
  Advancers,
  FeePayment,
}

export default [{
    label:'Upload Final Standings',
    current:true,
    disabled:false,
		completed:false,
		sequence:STEP_SEQUENCE.UploadFinalStandings,
		component:'EventResult'
	},
	{
    label:'Post Event Setup',
    current:false,
    disabled:true,
		completed:false,
		sequence:STEP_SEQUENCE.PostEventSetup,
		component:'PostEventSetup'
	},
	{
    label:'Advancers and Alternates',
    current:false,
		disabled:true,
		completed:false,
		sequence:STEP_SEQUENCE.Advancers,
		component:'RecordAdvancersAlternates'
	},
	{
    label:'Fees Payment',
    current:false,
    disabled:true,
		completed:false,
		sequence:STEP_SEQUENCE.FeePayment,
		component:'PayFees'
	},
]


// WEBPACK FOOTER //
// ./src/containers/postevent/logic/wizardSteps.js